import { isEqual } from "lodash-es";

import { FlowVersion, Schema } from "src/api/flowTypes";
import { SchemaUpdate } from "src/api/flowVersionQueries";
import { DiffViewContext } from "src/changeHistory/DiffViewModal/DiffViewContext";
import { DiffRevisionProps } from "src/changeHistory/DiffViewModal/DiffViewModal";
import { useDiffHighlighting } from "src/changeHistory/DiffViewModal/highlightDiffs";
import { editorWrapperClassName } from "src/changeHistory/DiffViewModal/NodeDiffView";
import { SchemaOptions } from "src/router/SearchParams";
import { SchemaEditor } from "src/schema/schemaEditor/SchemaEditor";

type PossibleSchemaTyping = Schema | object | undefined;

const noopMutateSchemaAsync = async (
  _variables: SchemaUpdate,
): Promise<FlowVersion> => ({}) as FlowVersion;

export const SchemaDiffView: React.FC<DiffRevisionProps> = ({
  change,
  previouseRevision,
}) => {
  useDiffHighlighting("schema-diff-before", "schema-diff-after");
  const schemaType = change?.diff?.output_schema
    ? SchemaOptions.Output
    : SchemaOptions.Input;
  const originalSchema =
    schemaType === SchemaOptions.Output
      ? (previouseRevision.output_schema as PossibleSchemaTyping)
      : (previouseRevision.input_schema as PossibleSchemaTyping);
  const changedSchema =
    schemaType === SchemaOptions.Output
      ? (change?.diff?.output_schema as PossibleSchemaTyping)
      : (change?.diff?.input_schema as PossibleSchemaTyping);

  const originalSchemaStrict =
    !originalSchema || isEqual(originalSchema, {})
      ? undefined
      : (originalSchema as Schema);

  const changedSchemaStrict =
    !changedSchema || isEqual(changedSchema, {})
      ? undefined
      : (changedSchema as Schema);

  return (
    <DiffViewContext
      value={{
        renderedInDiffView: true,
      }}
    >
      <div
        className="flex h-full min-h-0 w-full flex-1 flex-row justify-between gap-x-6 px-6 pt-4"
        data-loc="schema-diff-view"
      >
        <div
          className={editorWrapperClassName}
          data-loc="schema-diff-before"
          id="schema-diff-before"
        >
          {originalSchemaStrict && (
            <SchemaEditor
              flowVersionId={change.flow_version_id}
              mutateSchema={() => {}}
              mutateSchemaAsync={noopMutateSchemaAsync}
              schema={originalSchemaStrict}
              setSchemaInvalid={() => {}}
              type={schemaType}
              immutable
            />
          )}
        </div>
        <div
          className={editorWrapperClassName}
          data-loc="schema-diff-after"
          id="schema-diff-after"
        >
          {changedSchemaStrict && (
            <SchemaEditor
              flowVersionId={change.flow_version_id}
              mutateSchema={() => {}}
              mutateSchemaAsync={noopMutateSchemaAsync}
              schema={changedSchemaStrict}
              setSchemaInvalid={() => {}}
              type={schemaType}
              immutable
            />
          )}
        </div>
      </div>
    </DiffViewContext>
  );
};
